export type ReplyStatus = "Active" | "Disabled";

export interface QuickReplyCategory {
  value: string;
  label: string;
  description: string;
}

export const WEEK_DAYS = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"] as const;
export type WeekDay = typeof WEEK_DAYS[number];

export interface QuickReplySchedule {
  weekdays: boolean;
  weekends: boolean;
  useCustomDays: boolean;
  customDays: WeekDay[];
  startTime: string;
  endTime: string;
}

export interface QuickReply {
  id: string;
  categoryValue: string;
  message: string;
  addedBy: string;
  createdOn: string; // ISO date
  status: ReplyStatus;
  schedule: QuickReplySchedule;
}

export const QUICK_REPLY_CATEGORIES: QuickReplyCategory[] = [
  { value: "greetings", label: "Greetings", description: "Short greeting messages" },
  { value: "hold_waiting", label: "Hold and Waiting", description: "Please wait, checking that for you etc." },
];

export const emptySchedule = (): QuickReplySchedule => ({
  weekdays: false,
  weekends: false,
  useCustomDays: false,
  customDays: [],
  startTime: "",
  endTime: "",
});

const MONTHS = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

export const formatDate = (iso: string) => {
  if (!iso) return "—";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "—";
  return `${d.getDate()} ${MONTHS[d.getMonth()]}, ${d.getFullYear()}`;
};
